/**
 * TicketStatusBadge Component
 *
 * Displays ticket status with appropriate styling.
 */

import React from 'react';
import { Badge } from '../../../components/ui/Badge';
import type { SupportTicketStatus } from '../../../types/support-ticket.types';
import { statusLabels, statusColors } from '../../../types/support-ticket.types';

interface TicketStatusBadgeProps {
  status: SupportTicketStatus;
}

export const TicketStatusBadge: React.FC<TicketStatusBadgeProps> = ({ status }) => {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${statusColors[status]}`}>
      {statusLabels[status]}
    </span>
  );
};
